var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.312,
    height: 14.036,
    viewBox: "0 0 13.312 14.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.312,
    height: 14.036,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_5",
    "data-name": "Repeat Grid 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1655.007 -19.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_120262",
    d: "M8.179,5.794,5.9,3.515A.362.362,0,1,1,6.412,3l2.9,2.9a.362.362,0,0,1,0,.512l-2.9,2.9A.362.362,0,1,1,5.9,8.8L8.179,6.518H.362a.362.362,0,1,1,0-.724ZM9.053.724a.362.362,0,0,1,0-.724h2.173a1.811,1.811,0,0,1,1.811,1.811V10.5a1.811,1.811,0,0,1-1.811,1.811H9.053a.362.362,0,0,1,0-.724h2.173A1.086,1.086,0,0,0,12.312,10.5V1.811A1.086,1.086,0,0,0,11.226.724Z",
    transform: "translate(1667.819 20.055) rotate(90)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1d6118967a12c0c854b06ccd85121df9.svg";
export { ForwardRef as ReactComponent };